import AdminSchedule from "./pages/AdminSchedule";

function App() {
  return (
    <div className="App">
      <AdminSchedule />
    </div>
  );
}

export default App;
